import type {} from '@mui/x-date-pickers/themeAugmentation';
import { ControllerMonthPickerColor } from '../../palette';

export const MonthPickerComponent = {
  MuiMonthPicker: {
    styleOverrides: {
      root: {
        borderBottom: `1px solid ${ControllerMonthPickerColor.BorderNormal}`,
        borderTop: `1px solid ${ControllerMonthPickerColor.BorderNormal}`,
        padding: 8,
      },
    },
  },
};
